export default "__VITE_ASSET__iOhuxaiA__"